/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Contact,
  CreateCall201Response,
  CreateContactDto,
  Env,
  ParentAttributionDto,
  Partner,
  PartnerAddressProjection,
  PartnerProjection,
  UpdateEnvDto,
  UpdatePartnerDto,
} from '../models/index';
import {
    ContactFromJSON,
    ContactToJSON,
    CreateCall201ResponseFromJSON,
    CreateCall201ResponseToJSON,
    CreateContactDtoFromJSON,
    CreateContactDtoToJSON,
    EnvFromJSON,
    EnvToJSON,
    ParentAttributionDtoFromJSON,
    ParentAttributionDtoToJSON,
    PartnerFromJSON,
    PartnerToJSON,
    PartnerAddressProjectionFromJSON,
    PartnerAddressProjectionToJSON,
    PartnerProjectionFromJSON,
    PartnerProjectionToJSON,
    UpdateEnvDtoFromJSON,
    UpdateEnvDtoToJSON,
    UpdatePartnerDtoFromJSON,
    UpdatePartnerDtoToJSON,
} from '../models/index';

export interface AutoUpdatePartnerByIdRequest {
    id: number;
}

export interface CreateBySiretRequest {
    siret: string;
}

export interface CreateContactRequest {
    createContactDto: CreateContactDto;
}

export interface FindPartnersByListIdRequest {
    requestBody: Array<string>;
}

export interface GetBySiretIncludeRequest {
    siret: string;
}

export interface GetBySiretsIncludeRequest {
    sirets: any;
}

export interface GetContactsByListParentIdRequest {
    ids: Array<string>;
}

export interface GetContactsByParentIdRequest {
    id: number;
}

export interface GetOneByIdRequest {
    id: number;
}

export interface GetPartnerAddressByIdRequest {
    id: number;
}

export interface GetPartnerNameByIdRequest {
    id: number;
}

export interface GetPartnersByLocationRequest {
    lat: number;
    lng: number;
    radius: number;
}

export interface GetPartnersByParentIdRequest {
    id: number;
}

export interface GetProspectEnvByIdRequest {
    id: number;
}

export interface ParentAttributionByChildIdRequest {
    id: number;
    parentAttributionDto: ParentAttributionDto;
}

export interface SearchByNameIncludeRequest {
    name: string;
}

export interface UpdateEnvByPartnerIdRequest {
    id: number;
    updateEnvDto: UpdateEnvDto;
}

export interface UpdatePartnerByIdRequest {
    id: number;
    updatePartnerDto: UpdatePartnerDto;
}

export interface UpdateScorePartnerByIdRequest {
    id: number;
}

/**
 * 
 */
export class PartnerApi extends runtime.BaseAPI {

    /**
     * Auto update partner by id
     */
    async autoUpdatePartnerByIdRaw(requestParameters: AutoUpdatePartnerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Partner>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling autoUpdatePartnerById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/partner/{id}/auto_update`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerFromJSON(jsonValue));
    }

    /**
     * Auto update partner by id
     */
    async autoUpdatePartnerById(requestParameters: AutoUpdatePartnerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Partner> {
        const response = await this.autoUpdatePartnerByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create partner by Siret
     */
    async createBySiretRaw(requestParameters: CreateBySiretRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Partner>>> {
        if (requestParameters['siret'] == null) {
            throw new runtime.RequiredError(
                'siret',
                'Required parameter "siret" was null or undefined when calling createBySiret().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/partner/create_by_siret/{siret}`;
        urlPath = urlPath.replace(`{${"siret"}}`, encodeURIComponent(String(requestParameters['siret'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PartnerFromJSON));
    }

    /**
     * Create partner by Siret
     */
    async createBySiret(requestParameters: CreateBySiretRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Partner>> {
        const response = await this.createBySiretRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a contact
     */
    async createContactRaw(requestParameters: CreateContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCall201Response>> {
        if (requestParameters['createContactDto'] == null) {
            throw new runtime.RequiredError(
                'createContactDto',
                'Required parameter "createContactDto" was null or undefined when calling createContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/partner`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateContactDtoToJSON(requestParameters['createContactDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCall201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a contact
     */
    async createContact(requestParameters: CreateContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCall201Response> {
        const response = await this.createContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get partner by Ids
     */
    async findPartnersByListIdRaw(requestParameters: FindPartnersByListIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Partner>>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling findPartnersByListId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/partner/ids`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PartnerFromJSON));
    }

    /**
     * Get partner by Ids
     */
    async findPartnersByListId(requestParameters: FindPartnersByListIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Partner>> {
        const response = await this.findPartnersByListIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get partner by siret include
     */
    async getBySiretIncludeRaw(requestParameters: GetBySiretIncludeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Partner>>> {
        if (requestParameters['siret'] == null) {
            throw new runtime.RequiredError(
                'siret',
                'Required parameter "siret" was null or undefined when calling getBySiretInclude().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/partner/siret/{siret}`;
        urlPath = urlPath.replace(`{${"siret"}}`, encodeURIComponent(String(requestParameters['siret'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PartnerFromJSON));
    }

    /**
     * Get partner by siret include
     */
    async getBySiretInclude(requestParameters: GetBySiretIncludeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Partner>> {
        const response = await this.getBySiretIncludeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get partners by siret include
     */
    async getBySiretsIncludeRaw(requestParameters: GetBySiretsIncludeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        if (requestParameters['sirets'] == null) {
            throw new runtime.RequiredError(
                'sirets',
                'Required parameter "sirets" was null or undefined when calling getBySiretsInclude().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/partner/sirets/{sirets}`;
        urlPath = urlPath.replace(`{${"sirets"}}`, encodeURIComponent(String(requestParameters['sirets'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get partners by siret include
     */
    async getBySiretsInclude(requestParameters: GetBySiretsIncludeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getBySiretsIncludeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get contact by list parent_id
     */
    async getContactsByListParentIdRaw(requestParameters: GetContactsByListParentIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Contact>>> {
        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError(
                'ids',
                'Required parameter "ids" was null or undefined when calling getContactsByListParentId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/partner/{ids}/list/contacts`;
        urlPath = urlPath.replace(`{${"ids"}}`, encodeURIComponent(String(requestParameters['ids'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContactFromJSON));
    }

    /**
     * Get contact by list parent_id
     */
    async getContactsByListParentId(requestParameters: GetContactsByListParentIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Contact>> {
        const response = await this.getContactsByListParentIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get contact by parent_id
     */
    async getContactsByParentIdRaw(requestParameters: GetContactsByParentIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Contact>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getContactsByParentId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/partner/{id}/contacts`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContactFromJSON));
    }

    /**
     * Get contact by parent_id
     */
    async getContactsByParentId(requestParameters: GetContactsByParentIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Contact>> {
        const response = await this.getContactsByParentIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get partner by id
     */
    async getOneByIdRaw(requestParameters: GetOneByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Partner>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getOneById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/partner/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerFromJSON(jsonValue));
    }

    /**
     * Get partner by id
     */
    async getOneById(requestParameters: GetOneByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Partner> {
        const response = await this.getOneByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get partner address by id
     */
    async getPartnerAddressByIdRaw(requestParameters: GetPartnerAddressByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerAddressProjection>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPartnerAddressById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/partner/address/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerAddressProjectionFromJSON(jsonValue));
    }

    /**
     * Get partner address by id
     */
    async getPartnerAddressById(requestParameters: GetPartnerAddressByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerAddressProjection> {
        const response = await this.getPartnerAddressByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get partner name by id
     */
    async getPartnerNameByIdRaw(requestParameters: GetPartnerNameByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerProjection>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPartnerNameById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/partner/name/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerProjectionFromJSON(jsonValue));
    }

    /**
     * Get partner name by id
     */
    async getPartnerNameById(requestParameters: GetPartnerNameByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerProjection> {
        const response = await this.getPartnerNameByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search partner by location with lat lng and radius
     */
    async getPartnersByLocationRaw(requestParameters: GetPartnersByLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['lat'] == null) {
            throw new runtime.RequiredError(
                'lat',
                'Required parameter "lat" was null or undefined when calling getPartnersByLocation().'
            );
        }

        if (requestParameters['lng'] == null) {
            throw new runtime.RequiredError(
                'lng',
                'Required parameter "lng" was null or undefined when calling getPartnersByLocation().'
            );
        }

        if (requestParameters['radius'] == null) {
            throw new runtime.RequiredError(
                'radius',
                'Required parameter "radius" was null or undefined when calling getPartnersByLocation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['lat'] != null) {
            queryParameters['lat'] = requestParameters['lat'];
        }

        if (requestParameters['lng'] != null) {
            queryParameters['lng'] = requestParameters['lng'];
        }

        if (requestParameters['radius'] != null) {
            queryParameters['radius'] = requestParameters['radius'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/partner/location`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Search partner by location with lat lng and radius
     */
    async getPartnersByLocation(requestParameters: GetPartnersByLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getPartnersByLocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get partner by parent_id
     */
    async getPartnersByParentIdRaw(requestParameters: GetPartnersByParentIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Partner>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPartnersByParentId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/partner/{id}/company`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PartnerFromJSON));
    }

    /**
     * Get partner by parent_id
     */
    async getPartnersByParentId(requestParameters: GetPartnersByParentIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Partner>> {
        const response = await this.getPartnersByParentIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get partner env by id
     */
    async getProspectEnvByIdRaw(requestParameters: GetProspectEnvByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Env>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getProspectEnvById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/partner/env/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EnvFromJSON(jsonValue));
    }

    /**
     * Get partner env by id
     */
    async getProspectEnvById(requestParameters: GetProspectEnvByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Env> {
        const response = await this.getProspectEnvByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update parent_id of partner by id
     */
    async parentAttributionByChildIdRaw(requestParameters: ParentAttributionByChildIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Partner>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling parentAttributionByChildId().'
            );
        }

        if (requestParameters['parentAttributionDto'] == null) {
            throw new runtime.RequiredError(
                'parentAttributionDto',
                'Required parameter "parentAttributionDto" was null or undefined when calling parentAttributionByChildId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/partner/parent_attribution/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ParentAttributionDtoToJSON(requestParameters['parentAttributionDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerFromJSON(jsonValue));
    }

    /**
     * Update parent_id of partner by id
     */
    async parentAttributionByChildId(requestParameters: ParentAttributionByChildIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Partner> {
        const response = await this.parentAttributionByChildIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search partner by name include
     */
    async searchByNameIncludeRaw(requestParameters: SearchByNameIncludeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Partner>>> {
        if (requestParameters['name'] == null) {
            throw new runtime.RequiredError(
                'name',
                'Required parameter "name" was null or undefined when calling searchByNameInclude().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/partner/search/{name}`;
        urlPath = urlPath.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters['name'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PartnerFromJSON));
    }

    /**
     * Search partner by name include
     */
    async searchByNameInclude(requestParameters: SearchByNameIncludeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Partner>> {
        const response = await this.searchByNameIncludeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update env by id partner
     */
    async updateEnvByPartnerIdRaw(requestParameters: UpdateEnvByPartnerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Partner>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateEnvByPartnerId().'
            );
        }

        if (requestParameters['updateEnvDto'] == null) {
            throw new runtime.RequiredError(
                'updateEnvDto',
                'Required parameter "updateEnvDto" was null or undefined when calling updateEnvByPartnerId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/partner/{id}/env`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateEnvDtoToJSON(requestParameters['updateEnvDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerFromJSON(jsonValue));
    }

    /**
     * Update env by id partner
     */
    async updateEnvByPartnerId(requestParameters: UpdateEnvByPartnerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Partner> {
        const response = await this.updateEnvByPartnerIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update partner by id
     */
    async updatePartnerByIdRaw(requestParameters: UpdatePartnerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Partner>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePartnerById().'
            );
        }

        if (requestParameters['updatePartnerDto'] == null) {
            throw new runtime.RequiredError(
                'updatePartnerDto',
                'Required parameter "updatePartnerDto" was null or undefined when calling updatePartnerById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/partner/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePartnerDtoToJSON(requestParameters['updatePartnerDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerFromJSON(jsonValue));
    }

    /**
     * Update partner by id
     */
    async updatePartnerById(requestParameters: UpdatePartnerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Partner> {
        const response = await this.updatePartnerByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update score partner by id
     */
    async updateScorePartnerByIdRaw(requestParameters: UpdateScorePartnerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Partner>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateScorePartnerById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/partner/{id}/scoring`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerFromJSON(jsonValue));
    }

    /**
     * Update score partner by id
     */
    async updateScorePartnerById(requestParameters: UpdateScorePartnerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Partner> {
        const response = await this.updateScorePartnerByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
